import React from "react";
// import { trackEvent } from '../shared/tracking/tracking';
import ErrorBoundary from "./shared/components/error-boundary";
import Main from "./_card-button/main";

const CardButton = () => {
  // trackEvent("CardAttachmentsCardButton", { category: "BulkCardsAttachments", action: "opened" })

  return (
    <ErrorBoundary errorType="TopBoundryError">
      <Main />
    </ErrorBoundary>
  );
};

export default CardButton;
